<template>
  <div class="ruralInfo">
    <BannerSwiper :bannerData="ruralBannerList" />
    <div class="rural-info">
      <div class="article-content">
        <div class="article">
          <div class="detail-dec">
            <div
              class="html-show"
              ref="htmlShow"
              v-html="
                lan ? educationCentre.contentEn : educationCentre.contentCn
              "
            ></div>
          </div>
        </div>
      </div>
      <div class="share-box" v-if="!isIndex">
        <ShareQr :showApplet="false" :showExhibitionInfo="false" :showLodg="false" />
      </div>
    </div>
  </div>
</template>
<script>
import "swiper/dist/css/swiper.css";
import ShareQr from "../components/shareQr.vue";
import BannerSwiper from "../components/bannerSwiper.vue";

export default {
  name: "ruralInfo",
  components: {
    ShareQr,
    BannerSwiper,
  },
  data() {
    return {
      isIndex: false,
      content: "",
      pageIndex: 1,
      ruralBannerList: [],
      educationCentre: {},
      lan: this.$store.state.isEn,
      fontSizeClass: '',
    };
  },
  watch: {
    pageIndex(val, oldval) {},
    "$store.state.isEn"() {
      this.lan = this.$store.state.isEn;
      this.init();
    },
  },
  created() {
    // 获取当前屏幕宽度
    let screenWidth = window.innerWidth || document.documentElement.clientWidth;
    if (screenWidth < 961) {
      this.isIndex = true;
    }
    // 创建一个媒体查询，检查屏幕的宽度是否大于或等于 768px
    this.mediaQuery = window.matchMedia("(min-width: 961px)");
    // 添加事件侦听器，在状态更改时收到通知
    this.mediaQuery.addListener(this.handleMediaQueryChange);
  },
  beforeDestroy() {
    this.mediaQuery.removeListener(this.handleMediaQueryChange);
  },
  mounted() {
    localStorage.removeItem("path");
    localStorage.removeItem("columnId");
    this.init();
    this.updateFontSizeClass();
    window.addEventListener('resize', this.updateFontSizeClass);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateFontSizeClass);
  },
  methods: {
    handleMediaQueryChange(event) {
      if (event.matches) {
        this.isIndex = false;
      } else {
        this.isIndex = true;
      }
    },
    updateFontSizeClass() {
      const screenWidth = window.innerWidth;
      const htmlShowElement = this.$refs.htmlShow;
      
      if (!htmlShowElement) return;
      
      // 清除现有样式
      htmlShowElement.style.fontSize = '';
      const elements = htmlShowElement.querySelectorAll('*');
      elements.forEach(el => {
        el.style.fontSize = '';
        el.style.lineHeight = '';
      });
      
      // 根据屏幕宽度设置字体大小
      if (screenWidth <= 960) {
        // 小屏幕
        htmlShowElement.style.fontSize = '14px';
        const paragraphs = htmlShowElement.querySelectorAll('p');
        paragraphs.forEach(p => {
          p.style.fontSize = '14px';
          p.style.lineHeight = '24px';
          p.style.marginBottom = '12px';
        });
        
        const headings = htmlShowElement.querySelectorAll('h1, h2, h3, h4, h5, h6');
        headings.forEach((h, index) => {
          switch(h.tagName) {
            case 'H1': h.style.fontSize = '24px'; break;
            case 'H2': h.style.fontSize = '20px'; break;
            case 'H3': h.style.fontSize = '18px'; break;
            case 'H4': h.style.fontSize = '16px'; break;
            case 'H5': h.style.fontSize = '14px'; break;
            case 'H6': h.style.fontSize = '12px'; break;
          }
          h.style.margin = '16px 0';
          h.style.fontWeight = 'bold';
        });
        
        const images = htmlShowElement.querySelectorAll('img');
        images.forEach(img => {
          img.style.maxWidth = '100%';
          img.style.height = 'auto';
          img.style.marginBottom = '0px';
        });
      } else if (screenWidth <= 1440) {
        // 中等屏幕
        htmlShowElement.style.fontSize = '16px';
        const paragraphs = htmlShowElement.querySelectorAll('p');
        paragraphs.forEach(p => {
          p.style.fontSize = '16px';
          p.style.lineHeight = '28px';
          p.style.marginBottom = '14px';
        });
        
        const headings = htmlShowElement.querySelectorAll('h1, h2, h3, h4, h5, h6');
        headings.forEach((h, index) => {
          switch(h.tagName) {
            case 'H1': h.style.fontSize = '28px'; break;
            case 'H2': h.style.fontSize = '24px'; break;
            case 'H3': h.style.fontSize = '20px'; break;
            case 'H4': h.style.fontSize = '18px'; break;
            case 'H5': h.style.fontSize = '16px'; break;
            case 'H6': h.style.fontSize = '14px'; break;
          }
          h.style.margin = '16px 0';
          h.style.fontWeight = 'bold';
        });
        
        const images = htmlShowElement.querySelectorAll('img');
        images.forEach(img => {
          img.style.maxWidth = '100%';
          img.style.height = 'auto';
          img.style.marginBottom = '18px';
        });
      } else {
        // 大屏幕
        htmlShowElement.style.fontSize = '18px';
        const paragraphs = htmlShowElement.querySelectorAll('p');
        paragraphs.forEach(p => {
          p.style.fontSize = '18px';
          p.style.lineHeight = '32px';
          p.style.marginBottom = '16px';
        });
        
        const headings = htmlShowElement.querySelectorAll('h1, h2, h3, h4, h5, h6');
        headings.forEach((h, index) => {
          switch(h.tagName) {
            case 'H1': h.style.fontSize = '32px'; break;
            case 'H2': h.style.fontSize = '28px'; break;
            case 'H3': h.style.fontSize = '24px'; break;
            case 'H4': h.style.fontSize = '20px'; break;
            case 'H5': h.style.fontSize = '18px'; break;
            case 'H6': h.style.fontSize = '16px'; break;
          }
          h.style.margin = '16px 0';
          h.style.fontWeight = 'bold';
        });
        
        const images = htmlShowElement.querySelectorAll('img');
        images.forEach(img => {
          img.style.maxWidth = '100%';
          img.style.height = 'auto';
          img.style.marginBottom = '26px';
        });
      }
    },
    async init() {
      await this.$api.get(
        "/advert/list",
        { current: 1, pageSize: 10, advertFlagName: "rural_banner" },
        (r) => {
          const { data, code } = r;
          if (code == 0) {
            if (data && data.length > 0) {
              data.forEach((el) => {
                el.img = (el.image && JSON.parse(el.image)[0].src) || "";
              });
              this.ruralBannerList = JSON.parse(JSON.stringify(data));
            }
          }
        }
      );
      this.$api.get("/about/detail", {}, (r) => {
        const { data, code } = r;
        if (code == 0) {
          this.educationCentre = data;
          // DOM 更新后调整字体大小
          this.$nextTick(() => {
            this.updateFontSizeClass();
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.ruralInfo {
  margin-top: 94px;
}

.rural-info {
  position: relative;
  width: 1400px;
  height: 100%;
  margin: 0px auto 100px;
  background-color: #fff;
}
.article-content {
  width: 100%;
}
.article {
  width: 1100px;
  margin-top: 80px;
}
.article-title {
  font-family: SourceHanSansCN-Bold;
  font-size: 40px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  font-weight: Bold;
  margin-top: 70px;
}
.article-subtitle {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #98989f;
  letter-spacing: 0;
  text-align: left;
  font-weight: Regular;
  margin: 10px 0;
}
.article-info {
  font-family: SourceHanSansCN-Regular;
  font-size: 18px;
  color: #000000;
  letter-spacing: 0;
  text-align: left;
  line-height: 32px;
  font-weight: Regular;
  margin-bottom: 30px;
}
.share-box {
  position: absolute;
  right: 0px;
  top: 25px;
}
.rural-img {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-top: 70px;
}
.rural-img-show {
  width: 708px;
  height: 354px;
  margin-bottom: 26px;
  object-fit: cover;
}
.grey-line {
  margin-top: 70px;
  width: 100%;
  height: 1px;
  background: #d8d8d8;
}

.detail-dec {
  margin-bottom: 32px;
}

.html-show {
  font-size: 18px;
}

@media (max-width: 1440px) {
  .ruralInfo {
    margin-top: 80px;
    overflow: hidden;
  }

  .rural-info {
    position: relative;
    width: 98%;
    height: 100%;
    margin: 0px auto 80px;
    background-color: #fff;
  }
  .article-content {
    width: 80%;
    margin-left: 20px;
  }
  .article {
    width: 92%;
    margin: 50px auto;
  }
  .article-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 32px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    margin-top: 20px;
  }
  .article-subtitle {
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    color: #98989f;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
    margin: 10px 0;
  }
  .article-info {
    font-family: SourceHanSansCN-Regular;
    font-size: 18px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 32px;
    font-weight: Regular;
    margin-bottom: 10px;
  }
  .share-box {
    position: absolute;
    right: 20px;
    top: 105px;
  }
  .rural-img {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 0px;
  }
  .rural-img-show {
    width: 48%;
    height: auto;
    margin: 10px auto;
    object-fit: contain;
  }
  .grey-line {
    width: 92%;
    margin: 70px auto 0;
    height: 1px;
    background: #d8d8d8;
  }
  
  .detail-dec {
    margin-bottom: 24px;
  }
}
@media (max-width: 960px) {
  .ruralInfo {
    margin-top: 80px;
  }

  .rural-info {
    position: relative;
    width: 98%;
    height: 100%;
    margin: 0px auto 50px;
    background-color: #fff;
  }
  .article-content {
    width: 90%;
    margin: 0 auto;
  }
  .article {
    width: 100%;
    margin: 30px auto;
  }
  .article-title {
    font-family: SourceHanSansCN-Bold;
    font-size: 24px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    font-weight: Bold;
    margin-top: 20px;
  }
  .article-subtitle {
    font-family: SourceHanSansCN-Regular;
    font-size: 13px;
    color: #98989f;
    letter-spacing: 0;
    text-align: left;
    font-weight: Regular;
    margin: 10px 0;
  }
  .article-info {
    font-family: SourceHanSansCN-Regular;
    font-size: 13px;
    color: #000000;
    letter-spacing: 0;
    text-align: left;
    line-height: 24px;
    font-weight: Regular;
    margin-bottom: 10px;
  }
  .share-box {
    position: absolute;
    right: 0px;
    top: 105px;
  }
  .rural-img {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin-top: 0px;
  }
  .rural-img-show {
    width: 100%;
    height: auto;
    margin: 5px auto;
    object-fit: contain;
  }
  .grey-line {
    width: 92%;
    margin: 40px auto 0;
    height: 1px;
    background: #d8d8d8;
  }
  
  .detail-dec {
    margin-bottom: 16px;
  }
}
</style>